import state from './moduleNoticesState.js'
import mutations from './moduleNoticesMutations.js'
import actions from './moduleNoticesActions.js'
import getters from './moduleNoticesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
